import { render, staticRenderFns } from "./TextRecommendationCardTitleDetail.vue?vue&type=template&id=d1d4ba26&scoped=true"
import script from "./TextRecommendationCardTitleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationCardTitleDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationCardTitleDetail.vue?vue&type=style&index=0&id=d1d4ba26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d4ba26",
  null
  
)

export default component.exports